import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsPlayHighlightedMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M11.653 1.567C10.179.392 8 1.442 8 3.327v25.347c0 1.885 2.179 2.934 3.653 1.76l15.896-12.675a2.25 2.25 0 000-3.518z"
        fill=""
      />
    </svg>
  )
);
SvgActionsPlayHighlightedMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsPlayHighlightedMedium;
